/**
 * Konfigurasi klien. HANYA nilai yang memang publik.
 * Tidak ada service role key, tidak ada secret — apa pun di berkas ini ikut terkirim ke browser.
 */
import { resolveApiBaseUrl } from './lib/api-base-url';

export const config = {
  // Bukan `?? 'http://localhost:3300'`: `??` meloloskan STRING KOSONG, yang dihasilkan build
  // image tanpa `--build-arg` dan membuat setiap panggilan API menjadi relatif ke origin web.
  // Alasan lengkap dan ujinya ada di `lib/api-base-url.ts`.
  apiBaseUrl: resolveApiBaseUrl(import.meta.env.VITE_WORKFORCE_API_URL),

  /**
   * HBS API — sumber kebenaran keanggotaan organisasi (`GET /me/memberships`).
   *
   * Dipanggil LANGSUNG dari browser, pola yang sama dengan `apps/web`. Workforce API tidak dapat
   * menjawab pertanyaan ini: seluruh route-nya menuntut `x-organization-id`, sedangkan justru
   * itulah yang sedang dicari. Meneruskannya lewat Workforce akan menuntut route yang
   * terautentikasi tetapi tanpa konteks tenant — perubahan pada guard tenant, dan itu radius
   * ledak yang tidak sepadan untuk satu daftar.
   *
   * Prasyarat operasional: origin web ini harus terdaftar di `CORS_ORIGINS` milik HBS API.
   */
  hbsApiBaseUrl: resolveApiBaseUrl(import.meta.env.VITE_HBS_API_URL, 'http://localhost:3000'),

  // Anon key adalah kunci PUBLIK — ia memang dirancang untuk ikut ke browser; RLS dan JWT yang
  // mengamankan, bukan kerahasiaan kunci ini.
  supabaseUrl: resolveApiBaseUrl(import.meta.env.VITE_SUPABASE_URL, 'http://127.0.0.1:54321'),
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim(),

  /**
   * Basis URL unduhan biner agen telemetri (ADR-0055 Fase 3) — rilis publik di repo terpisah
   * (lihat docs/operations/workforce-agent-release-setup.md), mis.
   * `https://github.com/ahmadramadhanmusa/workforce-agent-dist/releases/latest/download`.
   *
   * KOSONG = fitur unduh biner MATI: tombol "Unduh biner" disembunyikan dan skrip pasang kembali
   * ke mode "biner disiapkan manual" (tak auto-unduh). Diisi owner setelah workflow rilis & repo
   * publik siap, supaya app tak pernah menautkan ke URL yang belum ada. Tanpa trailing slash.
   */
  agentDistBaseUrl: (import.meta.env.VITE_WORKFORCE_AGENT_DIST_URL ?? '').trim().replace(/\/$/, ''),
} as const;
